import { Box, SxProps, Theme, Typography } from '@mui/material';

const customStyles: Record<string, SxProps<Theme>> = {
  tabPanelContainer: {
    height: '100%',
    width: '100%',
  },
  tabPanelBox: {
    display: 'flex',
    alignItems: 'center',
    padding: '40px',
  },
  tabPanelTypography: {
    width: '100%',
  },
  tabPanelWithoutPadding: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px',
  },
};

export function TabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
  woPadding?: boolean;
}) {
  const { children, value, index } = props;
  const tabPanelBoxStyle = props.woPadding
    ? customStyles.tabPanelWithoutPadding
    : customStyles.tabPanelBox;

  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      sx={customStyles.tabPanelContainer}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box
          p={2}
          sx={tabPanelBoxStyle}
        >
          <Typography
            component={'span'}
            variant={'body2'}
            sx={customStyles.tabPanelTypography}
          >
            {children}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
